import {Action, createReducer, on} from '@ngrx/store';
import {
  OrganizationsList,
  OrganizationsListError,
  OrganizationsListSuccess,
  OrganizationUpdate,
  OrganizationUpdateSuccess,
  OrganizationUpdateError,
  OrganizationDelete,
  OrganizationDeleteSuccess,
  OrganizationDeleteError,
  OrganizationAdd,
  OrganizationAddSuccess,
  OrganizationAddError,
  ResetOrganizationState,
  OrganizationsListAll,
  OrganizationsListAllSuccess,
  OrganizationsListAllError,
  OrganizationGet,
  OrganizationGetSuccess,
  OrganizationGetError
} from '@app/stores/organization/organization.actions';
import {initialOrganizationState} from '@app/stores/organization/organization.state';

const generateReducer = createReducer(initialOrganizationState,
  on(OrganizationsListAll, (state) => ({
    ...state,
    organization: null,
    organizations: [],
    success: '',
    error: ''
  })),
  on(OrganizationsListAllSuccess, (state, {organizations}) => ({
    ...state,
    organization: null,
    organizations,
    success: '',
    error: ''
  })),
  on(OrganizationsListAllError, (state, {error}) => ({
    ...state,
    organization: null,
    organizations: [],
    success: '',
    error
  })),
  on(OrganizationsList, (state) => ({
    ...state,
    organization: null,
    paginatedOrganizations: null,
    success: '',
    error: ''
  })),
  on(OrganizationsListSuccess, (state, {paginatedOrganizations}) => ({
    ...state,
    organization: null,
    paginatedOrganizations,
    success: '',
    error: ''
  })),
  on(OrganizationsListError, (state, {error}) => ({
    ...state,
    organization: null,
    paginatedOrganizations: null,
    success: '',
    error
  })),
  on(OrganizationUpdate, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(OrganizationUpdateSuccess, (state) => ({
    ...state,
    success: 'Organization updated successfully',
    error: ''
  })),
  on(OrganizationUpdateError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(OrganizationDelete, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(OrganizationDeleteSuccess, (state) => ({
    ...state,
    success: 'Organization deleted successfully',
    error: ''
  })),
  on(OrganizationDeleteError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(OrganizationAdd, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(OrganizationAddSuccess, (state) => ({
    ...state,
    success: 'Organization added successfully',
    error: ''
  })),
  on(OrganizationAddError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(OrganizationGet, (state) => ({
    ...state,
    organization: null,
    success: '',
    error: ''
  })),
  on(OrganizationGetSuccess, (state, {organization}) => ({
    ...state,
    organization,
    success: '',
    error: ''
  })),
  on(OrganizationGetError, (state, {error}) => ({
    ...state,
    organization: null,
    success: '',
    error
  })),

  on(ResetOrganizationState, (state, {params}) => ({
    ...state,
    ...params
  })),
);

export function organizationReducer(state = initialOrganizationState, action: Action) {
  return generateReducer(state, action);
}
